const THEME_CACHE_KEY = '_themecolor';
const ELEMENT_ORIGINAL_THEME = '#409EFF'
export {
    ELEMENT_ORIGINAL_THEME
};

export function getTheme() {
    return window.localStorage.getItem(THEME_CACHE_KEY) || ELEMENT_ORIGINAL_THEME;
}

export function setTheme(theme: string) {
    window.localStorage.setItem(THEME_CACHE_KEY, theme);
}

/**
 * 是否默认Theme
 */
export function isDefaultTheme() {
    return getTheme() === ELEMENT_ORIGINAL_THEME;
}